
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CreateConversationModal from "@/components/inbox/CreateConversationModal.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import InboxAdd from "@/components/icons/InboxAdd.vue";
  import InboxAddHover from "@/components/icons/InboxAddHover.vue";


  @Component({
    components: {
      InboxAdd,
      CreateConversationModal,
      UiButton,
      InboxAddHover
    },
  })
  export default class NewConversationButtonWithModal extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly currentUserRole!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, default: undefined }) readonly size?: string;

    newConversationDialog: boolean = false;
  }
